import { fetchData } from 'video/shared/smart-tag-adapter/network-tools';

const KEY_MOMENTS_URL = '/live-tv/stream/keyMoments/{$gameID}/gameData.json';

export const getLiveKeyMomentsData = async (gameID, regionPrefix) => {
    let url = KEY_MOMENTS_URL.replace('{$gameID}', gameID);
    url = `${regionPrefix}${url}`;
    try {
        const response = await fetchData(url);
        const data = await response.json();
        if (!data.success) {
            return [];
        }
        return data.result?.keyMoments ?? [];
    } catch (error) {
        debug('Failed to fetch keymoments data:', error);
    }
};

const debug = (message, object) => {
    if (!window.smartTagAPI.debugEnabled) {
        return;
    }
    let label = 'KeyMoments Site: ';
    string = label + message;
    if (object === undefined) {
        window.console.log(string);
    } else {
        window.console.log(string, object);
    }
};
